import { RULES_TRANSLATION_KEYS } from '../constants/translations';

export const generateTranslationsKeyById = (key: string, id: string): string => `${key}__${id}`;

export const generateRulesTranslationsKeys = (id: string): string[] =>
    RULES_TRANSLATION_KEYS.map(key => generateTranslationsKeyById(key, id));
